import styled, { css } from 'styled-components';

export const Placeholder = styled.button<{ $showBigger: boolean }>(
  ({ theme, $showBigger }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    min-width: ${theme.sz.s24};
    min-height: ${theme.sz.s12};
    font-size: ${$showBigger ? theme.DEPRECATED_ty.largest : theme.DEPRECATED_ty.larger};
    border-radius: ${theme.sz.s4};
    padding: ${$showBigger ? `${theme.sz.s1} ${theme.sz.s8}` : `0 ${theme.sz.s8}`};
    outline: 0;
    background-color: ${theme.co.neutral95};
    border: ${theme.bo.mediumWidth} solid ${theme.co.neutral95};
    color: ${theme.co.secondary60};
    &:not(:first-of-type) {
      margin-inline-end: ${theme.sz.s4};
    }
  `,
);
